module.exports = __webpack_public_path__ + "statics/img/btn-8b8af5cc.png";


//////////////////
// WEBPACK FOOTER
// ./web/img/xhpopulrz/download/btn.png
// module id = 1209
// module chunks = 143